import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const errorDecoratorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // A route query can carry a login token or an email address, and this text reaches error reporting.
      const currentRoute = router.url.split(/[?#]/)[0];

      const decoratedError = {
        ...error,
        message: `[Route: ${currentRoute}] ${error.message}`,
        urlAtError: currentRoute,
      };

      return throwError(() => decoratedError);
    }),
  );
};
